import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AiIntegrationAuthInterceptor } from './interceptor/ai-integration-auth.interceptor';
import { EnvironmentType } from './classes/iqBoost';
import { AiFeaturesService } from './services/ai-features.service';
import { EmailService } from './services/email.service';
import { MaximizerAiService } from './services/maximizer-ai.service';
import { PiiAnonymizationService } from './services/pii-anonymization.service';
import { AIStore } from './state/ai.store';
import { IQBoostViewStore } from './state/iqboost-view.store';
import {
  INTEGRATION_IQ_BOOST_URL,
  INTEGRATION_SUBSCRIPTION_KEY,
  INTEGRATION_WEB_APP_URL,
  MAXIMIZER_AI_ENVIRONMENT,
} from './types/injection-token';
import { UdoService } from '@maximizer/core/shared/data-access';

/** Prompts resolve via IQ Boost API; Outlook still provides its own Langfuse tokens. */
export interface AiDataAccessConfig {
  environment: EnvironmentType;
  integrationWebAppUrl: string;
  integrationIqBoostUrl: string;
  integrationSubscriptionKey: string;
}

export function provideAiDataAccess(
  config?: AiDataAccessConfig,
): EnvironmentProviders {
  const configurationProviders = config
    ? [
        {
          provide: MAXIMIZER_AI_ENVIRONMENT,
          useValue: config.environment,
        },
        {
          provide: INTEGRATION_IQ_BOOST_URL,
          useValue: config.integrationIqBoostUrl,
        },
        {
          provide: INTEGRATION_WEB_APP_URL,
          useValue: config.integrationWebAppUrl,
        },
        {
          provide: INTEGRATION_SUBSCRIPTION_KEY,
          useValue: config.integrationSubscriptionKey,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AiIntegrationAuthInterceptor,
          multi: true,
        },
      ]
    : [];

  return makeEnvironmentProviders([
    AiFeaturesService,
    IQBoostViewStore,
    AIStore,
    MaximizerAiService,
    PiiAnonymizationService,
    UdoService,
    EmailService,
    ...configurationProviders,
  ]);
}
